import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  announceList: [],
  closedAnnounceList: [],
};

const slice = createSlice({
  initialState,
  name: "announcement",
  reducers: {
    fetchAnnounceList: (state) => {
      state.loading = true;
    },
    fetchAnnounceListSuccess: (state, action) => {
      state.loading = false;
      state.announceList = action.payload;
    },
    fetchAnnounceListFailure: (state) => {
      state.loading = false;
    },
    closeAnnounceItem: (state, action) => {
      state.closedAnnounceList = [...state.closedAnnounceList, action.payload];
    },
  },
});

export const { fetchAnnounceList, fetchAnnounceListSuccess, fetchAnnounceListFailure, closeAnnounceItem } =
  slice.actions;

export default slice;
